import React, { Component, forwardRef } from "react";
import { Redirect } from "react-router-dom";
import moment from "moment";
import DatePicker from "react-datepicker";
import { years, months, isWeekday } from "../../utils/CalendarHelpers";
import { getMonth, getYear } from "date-fns";
import { Row, Col, Container, Button, Spinner } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { isHoliyday } from "../../utils/StringUtils";
import { get, put, post, syncedCalDate } from "../../utils/DeApi";

import Header from "../App/Header/Header";
import Loader from "../Loader/Loader";
import ErrorHandler from "../ErrorHandler/ErrorHandler";
import SearchCriteria from "../Search/SearchCriteria/SearchCriteria";
import { Fragment } from "react";
import { isDevelopment } from "../../utils/env";
import "./Dashboard.scss";

class PGMDashboard extends Component {
  constructor(props) {
    super(props);
    this.subscribedPromises = [];

    this.state = {
      filedAt: moment().utc().subtract(1, "day").format("YYYY-MM-DD"),
      keywords: "",
    };
  }

  componentDidMount() {
    this.fetchFilings();
  }

  componentWillUnmount() {
    this.subscribedPromises.forEach((promise) => promise.cancel());
  }

  createIndex() {
    const { filedAt } = this.state;

    this.setState({ createIndexError: null, createIndexIsLoading: true });
    const searchFilingsPromise = post("/filings", {
      filedAt: filedAt,
      q: "",
    });
    searchFilingsPromise.promise
      .then((response) => {
        this.setState({
          filingsMeta: response.meta,
          createIndexError: null,
          createIndexIsLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled &&
          this.setState({
            createIndexError: error,
            createIndexIsLoading: false,
          });
      });
  }

  updateIndex() {
    const { filedAt, indexingMeta } = this.state;

    this.setState({ indexingError: null, indexingIsLoading: true });
    const searchFilingsPromise = put("search/filings", {
      filedAt: filedAt,
      force: true,
    });
    searchFilingsPromise.promise
      .then((response) => {
        this.setState({
          indexingMeta: indexingMeta
            ? indexingMeta.splice(0, 0, response.data)
            : [response.data],
          indexingError: null,
          indexingIsLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled &&
          this.setState({ indexingError: error, indexingIsLoading: false });
      });
  }

  fetchFilings() {
    let { filedAt } = this.state;
    this.setState({
      error: null,
      isLoading: true,
      filings: [],
      filingsMeta: null,
      indexing: null,
      indexingError: null,
      indexingIsLoading: false,
      createIndexError: null,
      createIndexIsLoading: false,
    });
    if (isHoliyday(filedAt) === 1) {
      filedAt = moment(filedAt).subtract(1, "days").format("YYYY-MM-DD");
      this.setState({ filedAt: filedAt });
    } else if (isHoliyday(filedAt) === 2) {
      filedAt = moment(filedAt).subtract(2, "days").format("YYYY-MM-DD");
      this.setState({ filedAt: filedAt });
    }
    setTimeout(() => {
      syncedCalDate(filedAt); /* *** setting date for calendars sync *** */
    }, 100);

    const searchFilingsPromise = get("/filings", {
      params: {
        filedAt: filedAt,
        formType: [""],
      },
    });

    searchFilingsPromise.promise
      .then((response) => {
        this.setState(
          {
            filings: response.data,
            filingsMeta: response.meta,
            error: null,
            isLoading: false,
          },
          () => this.fetchIndexingStatus()
        );
      })
      .catch((error) => {
        !error.isCanceled && this.setState({ error: error, isLoading: false });
      });

    this.subscribedPromises.push(searchFilingsPromise);
  }

  fetchIndexingStatus() {
    const { filedAt } = this.state;

    this.setState({
      indexingMeta: null,
      indexingError: null,
      indexingIsLoading: false,
    });
    const indexingStatusPromise = get("search/filings/status", {
      params: { filedAt: filedAt },
    });

    indexingStatusPromise.promise
      .then((response) => {
        this.setState({
          indexingMeta: response.data,
          indexingError: null,
          indexingIsLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled &&
          this.setState({ indexingError: error, indexingIsLoading: false });
      });
    this.subscribedPromises.push(indexingStatusPromise);
  }

  render() {
    const { isLoading } = this.state;
    if (isLoading) return <Loader />;
    return (
      <>
        <Header user={this.props.user} title={"Dashboard"} />
        <Container className="MainContent">
          <Row className="mt-3 mb-3">
            <Col xs={12} className="mt-2 mb-2">
              {this.renderSearchForm()}
              {/* {this.renderSearchableFilings()} */}
            </Col>
          </Row>
        </Container>
      </>
    );
  }

  renderSearchForm() {
    // var date = new Date();
    // const isWeekday = (date) => {
    //   const day = date.getDay();
    //   return day !== 0 && day !== 6;
    // };
    const { search, filedAt } = this.state;
    if (search)
      return (
        <Redirect
          push
          to={`/search?filedAt=${filedAt}&q=${encodeURIComponent(search)}`}
        />
      );

    const DateInput = forwardRef(({ value, onClick }, ref) => (
      <>
        <button
          className="btn btn-success-deal-style"
          onClick={onClick}
          style={{ marginRight: "4px" }}
        >
          {value}
          <span className="material-icons">expand_more</span>
        </button>
        <SearchCriteria optimization={false} filedAt={filedAt} />
      </>
    ));

    return (
      <div className="text-center mb-3">
        <h1>LeadsModule Dashboard</h1>
        <p>Search for documents in SEC EDGAR by keywords.</p>
        <div
          className="search-section"
          style={{ marginLeft: "auto", marginRight: "auto" }}
        >
          {/* <DatePicker
                  selected={moment(filedAt).toDate()}
                  popperPlacement="left-start"
                  filterDate={isWeekday}
                  dayClassName={()=>{
                    return "text-dark"
                  }}
                  onChange={(date) =>
                    this.setState(
                      { filedAt: moment(date).format("YYYY-MM-DD") },
                      () => this.fetchFilings()
                    )
                  }
                  customInput={<DateInput />}
                /> */}

          {/* <DatePicker
            portalId="root-portal"
            className="dashboardPicker"
            filterDate={isWeekday}
            dayClassName={() => {
              return "text-dark";
            }}
            onChange={(date) =>
              this.setState(
                { filedAt: moment(date).format("YYYY-MM-DD") },
                () => this.fetchFilings()
              )
            }
            customInput={<DateInput />}
            popperPlacement="left-start"
            renderCustomHeader={({
              date,
              changeYear,
              changeMonth,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
            }) => (
              <div
                style={{
                  margin: 10,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={decreaseMonth}
                  disabled={prevMonthButtonDisabled}
                >
                  {" "}
                  {"<"}{" "}
                </button>
                <select
                  value={getYear(date)}
                  onChange={({ target: { value } }) => changeYear(value)}
                >
                  {years.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
                <select
                  value={months[getMonth(date)]}
                  onChange={({ target: { value } }) =>
                    changeMonth(months.indexOf(value))
                  }
                >
                  {months.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
                <button
                  onClick={increaseMonth}
                  disabled={nextMonthButtonDisabled}
                >
                  {" "}
                  {">"}{" "}
                </button>
              </div>
            )}
            selected={moment(filedAt).toDate()}
          /> */}
          <div className="sticky-divider" />
        </div>
      </div>
    );
  }

  renderSearchableFilings() {
    const {
      filingsMeta,
      filedAt,
      createIndexIsLoading,
      indexingMeta,
      indexingIsLoading,
    } = this.state;

    const { isLoading, error } = this.state;
    if (isLoading) return <Loader />;
    if (error) return <ErrorHandler error={error} />;
    return (
      <div className="row">
        <div className="col-12">
          <h3 style={{ textAlign: "center" }}>
            <big>{filingsMeta ? filingsMeta.totals : 0}</big> filings available
            for {moment(filedAt).format("LL")}
          </h3>
          {/* {isDevelopment() ? (
          <p className="text-center">
            <Button
              size="sm"
              variant="outline-primary"
              onClick={() => this.createIndex()}
            >
              {createIndexIsLoading && (
                <Spinner as="span" size="sm" role="status" animation="border" />
              )}{" "}
              {filingsMeta && filingsMeta.totals
                ? "Refetch Filings from SEC"
                : "Fetch Filings from SEC"}
              <Spinner />
            </Button>{" "}

            <Button
              size="sm"
              variant="outline-primary"
              onClick={() => this.updateIndex()}
            >
              {indexingIsLoading && (
                <Spinner as="span" size="sm" role="status" animation="border" />
              )}{" "}
              {indexingMeta ? "Refetch" : "Fetch"} Documents
            </Button>
          </p>
        ) : null} */}

          {filingsMeta && filingsMeta.totals
            ? this.renderSearchableDocuments()
            : ""}
        </div>
        {/* </div> */}
      </div>
    );
  }

  renderSearchableDocuments() {
    const { indexingMeta, indexingIsLoading } = this.state;
    // var latestIndexing = indexingMeta?.slice(-1).pop();
    let latestIndexing = indexingMeta;
    return (
      <div className="text-center">
        {/* <h4>
          Fetching History.{" "}
          {latestIndexing?.status === 3 ? (
            <span className="badge badge-success">Fetching Completed</span>
          ) : latestIndexing?.status === 2 ? (
            <span className="badge badge-warning">Fetching in Progress</span>
          ) : latestIndexing?.status === 1 ? (
            <span className="badge badge-info">Fetching Queued</span>
          ) : (
            <span className="badge badge-dark">Fetching Unstarted</span>
          )}
        </h4> */}
        <h4>
          Fetching History.{" "}
          {latestIndexing?.status === 4 && latestIndexing?.total > 0 ? (
            <span className="badge badge-success">Fetching Completed</span>
          ) : (
            <span className="badge badge-dark">Fetching Unstarted</span>
          )}
        </h4>

        {/* {indexingMeta &&
            indexingMeta.map((indexing) => (
              <Fragment key={indexing.id}>
                {indexing?.status === 3 ? (
                  <Fragment>
                    <p>
                      {moment(indexing.createdAt).format("LL")}{" "}
                      {moment(indexing.createdAt).format("hh:mm a")}: Documents
                      fetching started.
                    </p>
                    <p>
                      {moment(indexing.updatedAt).format("LL")}{" "}
                      {moment(indexing.updatedAt).format("hh:mm a")}: Documents
                      fetching completed.
                    </p>
                  </Fragment>
                ) : indexing?.status === 2 ? (
                  <p>
                    {moment(indexing.createdAt).format("LL")}{" "}
                    {moment(indexing.createdAt).format("hh:mm a")}: Documents
                    fetching started.
                  </p>
                ) : indexing?.status === 1 ? (
                  <p>
                    {moment(indexing.createdAt).format("LL")}{" "}
                    {moment(indexing.createdAt).format("hh:mm a")}: Documents
                    fetching queued.
                  </p>
                ) : (
                  ""
                )}
              </Fragment>
            ))} */}
        {
          <Fragment key={indexingMeta?.id}>
            {indexingMeta?.status === 3 ? (
              <Fragment>
                <p>
                  {moment(indexingMeta.createdAt).format("LL")}{" "}
                  {moment(indexingMeta.createdAt).format("hh:mm a")}: Documents
                  fetching started.
                </p>
                <p>
                  {moment(indexingMeta.updatedAt).format("LL")}{" "}
                  {moment(indexingMeta.updatedAt).format("hh:mm a")}: Documents
                  fetching completed.
                </p>
              </Fragment>
            ) : indexingMeta?.status === 2 ? (
              <p>
                {moment(indexingMeta.createdAt).format("LL")}{" "}
                {moment(indexingMeta.createdAt).format("hh:mm a")}: Documents
                fetching started.
              </p>
            ) : indexingMeta?.status === 1 ? (
              <p>
                {moment(indexingMeta.createdAt).format("LL")}{" "}
                {moment(indexingMeta.createdAt).format("hh:mm a")}: Documents
                fetching queued.
              </p>
            ) : (
              ""
            )}
          </Fragment>
        }
      </div>
    );
  }
}

PGMDashboard.propTypes = {};

export default PGMDashboard;
